import { AvatarSizeProps } from 'components/avatar'
import {
  defaultBgImageBase64,
  defaultPropfileIconBase64,
} from 'config/constants'
import { useEffect, useState } from 'react'
import { styled, CSS } from 'theme'
import { Box } from './Box'

export const ImageShimmerCss = styled(Box, {
  variants: {
    size: {
      xxs: {
        width: '$size$16',
        height: '$size$16',
        p: '$space$2',
      },
      xs: {
        width: '$size$20',
        height: '$size$20',
        p: '$space$2',
      },
      sm: {
        width: '$size$32',
        height: '$size$32',
        p: '$space$2',
      },
      md: {
        width: '$size$40',
        height: '$size$40',
        p: '$space$3',
      },
      lg: {
        width: '$size$48',
        height: '$size$48',
        p: '$space$4',
      },
      xl: {
        width: '$size$56',
        height: '$size$56',
        p: '$space$4',
      },
      login: {
        width: '$size$48',
        height: '$size$48',
        p: '$space$4',
      },
      level1: {
        width: '$size$48',
        height: '$size$48',
        p: '$space$4',
      },
      level2: {
        width: '$size$48',
        height: '$size$48',
        p: '$space$4',
      },
      level3: {
        width: '$size$48',
        height: '$size$48',
        p: '$space$4',
      },
      full: {
        width: '100%',
        height: '100%',
        borderRadius: 0,
        boxShadow: 'none',
      },
      auto: {
        width: 'auto',
        height: 'auto',
        borderRadius: 0,
        boxShadow: 'none',
      },
      100: {
        width: 100,
        height: 100,
        objectFit: 'cover',
        borderRadius: '$radii$xs',
        boxShadow: 'none',
      },
      120: {
        width: 120,
        height: 120,
      },
      160: {
        width: 160,
        height: 160,
      },
      rectangle: {
        width: 180,
        height: 120,
        objectFit: 'contain',
        boxShadow: 'none',
      },
      container: {},
    },
  },
  defaultVariants: {
    size: 'full',
  },
})

const ImageCss = styled('img', {
  // Reset
  //borderRadius: '$radii$rounded',
  objectFit: 'cover',
  boxShadow: '$dropdownBoxShadow',

  variants: {
    size: {
      xxs: {
        width: '$size$16',
        height: '$size$16',
        p: '$space$2',
      },
      xs: {
        width: '$size$20',
        height: '$size$20',
        p: '$space$2',
      },
      sm: {
        width: '$size$32',
        height: '$size$32',
        p: '$space$2',
      },
      md: {
        width: '$size$40',
        height: '$size$40',
        p: '$space$3',
      },
      lg: {
        width: '$size$48',
        height: '$size$48',
        p: '$space$4',
      },
      xl: {
        width: '$size$56',
        height: '$size$56',
        p: '$space$4',
      },
      login: {
        width: '$size$48',
        height: '$size$48',
        p: '$space$4',
      },
      level1: {
        width: '$size$48',
        height: '$size$48',
        p: '$space$4',
      },
      level2: {
        width: '$size$48',
        height: '$size$48',
        p: '$space$4',
      },
      level3: {
        width: '$size$48',
        height: '$size$48',
        p: '$space$4',
      },
      full: {
        width: '100%',
        height: '100%',
        borderRadius: 0,
        boxShadow: 'none',
      },
      auto: {
        width: 'auto',
        height: 'auto',
        borderRadius: 0,
        boxShadow: 'none',
      },
      100: {
        width: 100,
        height: 100,
        objectFit: 'cover',
        borderRadius: '$radii$xs',
        boxShadow: 'none',
      },
      120: {
        width: 120,
        height: 120,
      },
      160: {
        width: 160,
        height: 160,
      },
      300: {
        width: 300,
        height: 200,
        borderRadius: 0,
        objectFit: 'contain',
        boxShadow: 'none',
      },
      rectangle: {
        width: 180,
        height: 120,
        objectFit: 'contain',
        boxShadow: 'none',
      },
      container: {},
    },
  },
  defaultVariants: {
    size: 'full',
  },
})

interface ImageProps {
  className?: string
  size?:
    | AvatarSizeProps
    | 'full'
    | 'auto'
    | '100'
    | '120'
    | '160'
    | '300'
    | 'rectangle'
  url: string
  css?: CSS
  isIcon?: boolean
  isLoading?: boolean
}

export const Image = ({
  className,
  size,
  css,
  isIcon,
  url,
  isLoading,
}: ImageProps) => {
  const [imageSrc, setImageSrc] = useState(url)
  const [iconCss, setIconCss] = useState({})
  const [error, setError] = useState(false)

  useEffect(() => {
    setImageSrc(url)
  }, [url])

  const handleImageError = () => {
    setError(true)
    isIcon
      ? setImageSrc(defaultPropfileIconBase64)
      : setImageSrc(defaultBgImageBase64)
    setIconCss(
      isIcon ? { background: '$gray100', p: '$space$6 !important' } : {}
    )
  }

  const splitUrl = url?.split('/')
  const alternative = splitUrl?.[splitUrl.length - 1]
  const alternativeText = alternative?.includes('.')
    ? alternative.split('.')[0]
    : alternative

  return (
    <>
      <ImageCss
        onError={handleImageError}
        className={error ? `hasImageError ${className}` : className}
        size={size}
        onLoad={() => isLoading}
        src={imageSrc}
        alt={alternativeText}
        css={{ ...css, ...iconCss }}
        loading="lazy"
      />
    </>
  )
}
